<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'VButton',
  functional: true,
  render(h, context) {
    return h(VBtn, context.data, context.children)
  },
}
</script>

<style lang="scss">
.v-btn:not(.v-btn--outlined, .v-btn--text) {
  &::before {
    background-color: #000000;
  }

  .v-ripple__container {
    color: #000000;
  }
}
</style>
